import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Gap, RefreshButton } from "../../atoms";
// import Paper from "@mui/material/Paper";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import "./detailIkhtisar.css";
import SkeletonOverview from "./SkeletonOverview";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import "react-datepicker/dist/react-datepicker.css";
import {
  getOverviewKabkot,
  getOverviewProvinsi,
  getOverviewKecamatan,
  getOverviewKelurahan,
  getOverviewRtRw,
  getOverviewKomisarisBasis,
} from "../../../config/Redux/Overview/actions";
import { getTrendAnggota } from "../../../config/Redux/Anggota/actions";
import { getPengurusOverview } from "../../../config/Redux/Pengurus/actions";
import { getJumlahPusatOverview } from "../../../config/Redux/Dokumen/actions";
import { getExcoPusat } from "../../../config/Redux/ExcoPusat/actions";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const DetailOverview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let params = useParams();
  const [startDate] = useState(new Date());
  const [toggle] = useState("hari");
  const [verified_region] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleLoader = (value) => {
    setLoader(value);
  };

  const dataOverview = useSelector((state) => state.overview);
  const dataTrend = useSelector((state) => state.anggota.dataAnggotaTrend);
  const dataPengurus = useSelector(
    (state) => state.pengurus.dataPengurusOverview,
  );
  const dataPusatOverview = useSelector(
    (state) => state.dokumen.dataPusatOverview,
  );
  const dataExcoPusat = useSelector((state) => state.excopusat.dataExcoPusat);

  // console.log({ dataExcoPusat });

  useEffect(() => {
    const fetchData = async () => {
      // Check if data already exists in Redux store (cache check)
      const hasExistingData =
        dataOverview?.dataOverviewProvinsi?.data?.data?.length > 0 &&
        dataOverview?.dataOverviewKabkot?.data?.data?.length > 0 &&
        dataOverview?.dataOverviewKecamatan?.data?.data?.length > 0;

      if (hasExistingData) {
        // Data already exists, skip fetching
        return;
      }

      handleLoader(true);
      dispatch(getOverviewProvinsi(true));
      dispatch(getOverviewKecamatan(false));
      dispatch(getOverviewKelurahan(false));
      dispatch(getOverviewRtRw(false));
      dispatch(getOverviewKomisarisBasis(false));
      dispatch(getTrendAnggota("1", 0, toJSONLocal(startDate), toggle));
      dispatch(getPengurusOverview(null, null));
      dispatch(getJumlahPusatOverview());
      dispatch(getExcoPusat());
      let a = await dispatch(getOverviewKabkot(true));
      if (a) {
        handleLoader(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, params?.officeId]);

  // Force refresh function (bypasses cache)
  const handleRefresh = async () => {
    handleLoader(true);
    dispatch(getOverviewProvinsi(true));
    dispatch(getOverviewKecamatan(false));
    dispatch(getOverviewKelurahan(false));
    dispatch(getOverviewRtRw(false));
    dispatch(getOverviewKomisarisBasis(false));
    dispatch(getTrendAnggota("1", 0, toJSONLocal(startDate), toggle));
    dispatch(getPengurusOverview(null, null));
    dispatch(getJumlahPusatOverview());
    dispatch(getExcoPusat());
    let a = await dispatch(getOverviewKabkot(true));
    if (a) {
      handleLoader(false);
    }
  };

  const persentase = (penyebut, pembagi, decimal) => {
    let persen = 0;
    if (parseFloat(pembagi) !== 0 && parseFloat(penyebut) !== 0) {
      persen = ((parseFloat(penyebut) / parseFloat(pembagi)) * 100).toFixed(
        decimal,
      );
    }
    return persen;
  };

  const countAnggota = (data, is_verified, key = "jumlah_anggota_2029") => {
    let count = 0;
    for (let i = 0; i < data?.length; i++) {
      if (is_verified) {
        if (data[i].is_verified === 1) {
          count = count + (data[i][key] || 0);
        }
      } else {
        if (data[i].is_verified === 0) {
          count = count + (data[i][key] || 0);
        }
      }
    }
    return count;
  };
  const countTotalAnggota = (data, key = "jumlah_anggota_2029") => {
    let count = 0;
    for (let i = 0; i < data?.length; i++) {
      count = count + (data[i][key] || 0);
    }
    return count;
  };

  const countAnggotaTarget = (data, is_verified, target) => {
    let countTarget = 0;
    for (let i = 0; i < data?.length; i++) {
      if (is_verified) {
        if (data[i].is_verified === 1) {
          if (target === "pb") {
            countTarget = countTarget + data[i].target_pb;
          } else {
            countTarget = countTarget + data[i].target_kpu;
          }
        }
      } else {
        if (target === "pb") {
          countTarget = countTarget + data[i].target_pb;
        } else {
          countTarget = countTarget + data[i].target_kpu;
        }
      }
    }
    return countTarget;
  };

  // const countAnggotaPercentage = (data, is_verified, target) => {
  //   let count = 0;
  //   let countTarget = 0;
  //   for (let i = 0; i < data?.length; i++) {
  //     if (is_verified) {
  //       if (data[i].is_verified === 1) {
  //         count = count + data[i].jumlah_anggota;
  //         if (target === "pb") {
  //           countTarget = countTarget + data[i].target_pb;
  //         } else {
  //           countTarget = countTarget + data[i].target_kpu;
  //         }
  //       }
  //     } else {
  //       count = count + data[i].jumlah_anggota;
  //       if (target === "pb") {
  //         countTarget = countTarget + data[i].target_pb;
  //       } else {
  //         countTarget = countTarget + data[i].target_kpu;
  //       }
  //     }
  //   }
  //   let progress = 0;
  //   if (count === 0 || countTarget === 0) {
  //     progress = 0;
  //   } else {
  //     progress = (count / countTarget) * 100;
  //   }
  //   return progress;
  // };

  const countPengurusDaerah = (data, is_verified, daerah) => {
    let count = 0;
    for (let i = 0; i < data?.length; i++) {
      if (is_verified) {
        if (data[i].is_verified === 1) {
          if (data[i][daerah] > 0) {
            count++;
          }
        }
      } else {
        if (data[i][daerah] > 0) {
          count++;
        }
      }
    }
    return count;
  };

  // const countPengurusAverage = (data, level, daerah, is_verified) => {
  //   let temp = data || [];
  //   temp.sort((a, b) => (a[level] > b[level] ? 1 : -1));
  //   let count = -1;
  //   let province = [];
  //   let provinceCity = [];
  //   let tempWord = "";
  //   for (let i = 0; i < temp?.length; i++) {
  //     if (tempWord !== temp[i][level]) {
  //       count++;
  //       tempWord = temp[i][level];
  //       province[count] = 0;
  //       provinceCity[count] = 0;
  //       if (is_verified) {
  //         if (data[i].is_verified === 1) {
  //           if (temp[i][daerah] > 0) {
  //             province[count]++;
  //           }
  //           provinceCity[count]++;
  //         }
  //       } else {
  //         if (temp[i][daerah] > 0) {
  //           province[count]++;
  //         }
  //         provinceCity[count]++;
  //       }
  //     } else {
  //       if (is_verified) {
  //         if (data[i].is_verified === 1) {
  //           if (temp[i][daerah] > 0) {
  //             province[count]++;
  //           }
  //           provinceCity[count]++;
  //         }
  //       } else {
  //         if (temp[i][daerah] > 0) {
  //           province[count]++;
  //         }
  //         provinceCity[count]++;
  //       }
  //     }
  //   }

  //   let result = 0;
  //   for (let i = 0; i < province?.length; i++) {
  //     result = result + province[i] / provinceCity[i];
  //   }
  //   result = persentase(result, province?.length, 2);
  //   return result;
  // };

  /* countDokumenDaerah & countDokumenAverage - replaced by countDokumenLengkapSummary
  const countDokumenDaerah = (data, is_verified, daerah) => {
    let count = 0;
    for (let i = 0; i < data?.length; i++) {
      if (is_verified) {
        if (data[i].is_verified === 1) {
          if (daerah === "provinsi" || daerah === "kabkot") {
            if (
              data[i]?.info_dokumen?.dokumen_domisili === 1 &&
              data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
              data[i]?.info_dokumen?.dokumen_kesbangpol === 1 &&
              data[i]?.info_dokumen?.dokumen_rekening === 1 &&
              data[i]?.info_dokumen?.dokumen_sewa_kantor === 1 &&
              data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
            ) {
              count++;
            }
          } else if (daerah === "kecamatan") {
            if (
              // data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
              data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
            ) {
              count++;
            }
          }
        }
      } else {
        if (daerah === "provinsi" || daerah === "kabkot") {
          if (
            data[i]?.info_dokumen?.dokumen_domisili === 1 &&
            data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
            data[i]?.info_dokumen?.dokumen_kesbangpol === 1 &&
            data[i]?.info_dokumen?.dokumen_rekening === 1 &&
            data[i]?.info_dokumen?.dokumen_sewa_kantor === 1 &&
            data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
          ) {
            count++;
          }
        } else if (daerah === "kecamatan") {
          if (
            // data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
            data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
          ) {
            count++;
          }
        }
      }
    }
    return count;
  };

  const countDokumenAverage = (data, level, daerah, is_verified) => {
    let temp = data || [];
    temp.sort((a, b) => (a[level] > b[level] ? 1 : -1));
    let count = -1;
    let province = [];
    let provinceCity = [];
    let tempWord = "";
    for (let i = 0; i < temp?.length; i++) {
      if (tempWord !== temp[i][level]) {
        count++;
        tempWord = temp[i][level];
        province[count] = 0;
        provinceCity[count] = 0;
        if (is_verified) {
          if (data[i].is_verified === 1) {
            if (daerah === "provinsi") {
              if (
                data[i]?.info_dokumen?.dokumen_domisili === 1 &&
                data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
                data[i]?.info_dokumen?.dokumen_kesbangpol === 1 &&
                data[i]?.info_dokumen?.dokumen_rekening === 1 &&
                data[i]?.info_dokumen?.dokumen_sewa_kantor === 1 &&
                data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
              ) {
                province[count]++;
              }
            } else if (daerah === "kabkot") {
              if (
                // data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
                data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
              ) {
                province[count]++;
              }
            }
            provinceCity[count]++;
          }
        } else {
          if (daerah === "provinsi") {
            if (
              data[i]?.info_dokumen?.dokumen_domisili === 1 &&
              data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
              data[i]?.info_dokumen?.dokumen_kesbangpol === 1 &&
              data[i]?.info_dokumen?.dokumen_rekening === 1 &&
              data[i]?.info_dokumen?.dokumen_sewa_kantor === 1 &&
              data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
            ) {
              province[count]++;
            }
          } else if (daerah === "kabkot") {
            if (
              // data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
              data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
            ) {
              province[count]++;
            }
          }
          provinceCity[count]++;
        }
      } else {
        // console.log(data[i])
        if (is_verified) {
          if (data[i].is_verified === 1) {
            if (daerah === "provinsi") {
              if (
                data[i]?.info_dokumen?.dokumen_domisili === 1 &&
                data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
                data[i]?.info_dokumen?.dokumen_kesbangpol === 1 &&
                data[i]?.info_dokumen?.dokumen_rekening === 1 &&
                data[i]?.info_dokumen?.dokumen_sewa_kantor === 1 &&
                data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
              ) {
                province[count]++;
              }
            } else if (daerah === "kabkot") {
              if (
                // data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
                data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
              ) {
                province[count]++;
              }
            }
            provinceCity[count]++;
          }
        } else {
          if (daerah === "provinsi") {
            if (
              data[i]?.info_dokumen?.dokumen_domisili === 1 &&
              data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
              data[i]?.info_dokumen?.dokumen_kesbangpol === 1 &&
              data[i]?.info_dokumen?.dokumen_rekening === 1 &&
              data[i]?.info_dokumen?.dokumen_sewa_kantor === 1 &&
              data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
            ) {
              province[count]++;
            }
          } else if (daerah === "kabkot") {
            if (
              // data[i]?.info_dokumen?.dokumen_foto_kantor === 1 &&
              data[i]?.info_dokumen?.dokumen_sk_pengurus === 1
            ) {
              province[count]++;
            }
          }
          provinceCity[count]++;
        }
      }
    }
    let result = 0;
    for (let i = 0; i < province?.length; i++) {
      let t = province[i] / provinceCity[i] ? province[i] / provinceCity[i] : 0;
      result = result + t;
    }
    result = persentase(result, province?.length, 2);
    return result;
  };
  */

  const countDaerah = (data, is_verified) => {
    let count = 0;
    for (let i = 0; i < data?.length; i++) {
      if (is_verified) {
        if (data[i].is_verified === 1) {
          count++;
        }
      } else {
        count++;
      }
    }
    return count;
  };

  // Function to count total pengurus and pengurus perempuan
  const countPengurusPerempuanSummary = (data, pengurusKey, perempuanKey) => {
    let totalPengurus = 0;
    let totalPerempuan = 0;
    const perProvinsi = [];

    if (!data || data.length === 0) {
      return { total: 0, perempuan: 0, persen: 0, perProvinsi: [] };
    }

    for (let i = 0; i < data.length; i++) {
      const pengurus = parseInt(data[i]?.[pengurusKey]) || 0;
      const perempuan = parseInt(data[i]?.[perempuanKey]) || 0;
      totalPengurus += pengurus;
      totalPerempuan += perempuan;

      // Collect per-province data
      const namaProvinsi =
        data[i]?.nama_provinsi ||
        data[i]?.nama_kab_kot ||
        data[i]?.nama_kecamatan ||
        "-";
      const persenItem =
        pengurus > 0 ? ((perempuan / pengurus) * 100).toFixed(0) : 0;
      perProvinsi.push({
        nama: namaProvinsi,
        pengurus,
        perempuan,
        persen: persenItem,
      });
    }

    const persen =
      totalPengurus > 0
        ? ((totalPerempuan / totalPengurus) * 100).toFixed(0)
        : 0;

    return {
      total: totalPengurus,
      perempuan: totalPerempuan,
      persen,
      perProvinsi,
    };
  };

  const countDokumenLengkapSummary = (data, dokumenKey = "info_dokumen") => {
    if (!data || data.length === 0) {
      return { terisi: 0, total: 0 };
    }

    let total = 0;
    let terisi = 0;

    for (let i = 0; i < data.length; i++) {
      const dokumen = data[i]?.[dokumenKey];
      if (!dokumen) continue;
      const keys = Object.keys(dokumen);
      total += keys.length;
      for (let j = 0; j < keys.length; j++) {
        if (parseInt(dokumen[keys[j]]) >= 1) {
          terisi++;
        }
      }
    }

    return { terisi, total };
  };

  const toJSONLocal = (date) => {
    var local = new Date(date);
    local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
  };

  const convertDate = (date) => {
    let months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ];
    var local = new Date(date);
    return (
      local.getDate() +
      " " +
      months[local.getMonth()] +
      " " +
      local.getFullYear()
    );
  };

  const dataChartLabel = (datas) => {
    let val = [];
    if (datas) {
      datas.sort((a, b) => (a.waktu > b.waktu ? 1 : -1));
      datas.forEach((data) => {
        val.push(convertDate(data.waktu));
      });
    }
    return val;
  };

  const dataChartDataset = (datas) => {
    let val = [];
    if (datas) {
      datas.sort((a, b) => (a.waktu > b.waktu ? 1 : -1));
      datas.forEach((data) => {
        val.push(data.jumlah);
      });
    }
    return val;
  };
  const labels = dataChartLabel(dataTrend?.data);
  const data = {
    labels,
    datasets: [
      {
        label: "Jumlah Anggota",
        data: dataChartDataset(dataTrend?.data),
        borderColor: "rgb(240, 101, 36)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "Trend Pendaftaran Anggota",
        align: "start",
        padding: {
          bottom: 20,
        },
        font: {
          size: 16,
          weight: "bold",
        },
        color: "#333",
      },
      tooltip: {
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        titleColor: "#333",
        bodyColor: "#666",
        borderColor: "#f06524",
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        ticks: {
          maxRotation: 45,
          minRotation: 45,
          font: {
            size: 11,
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "#f5f5f5",
        },
        ticks: {
          font: {
            size: 11,
          },
        },
      },
    },
  };

  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <Gap height={20} />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <p style={{ fontSize: 24, fontWeight: 700, marginBottom: "4px" }}>
          Ikhtisar
        </p>
        <RefreshButton onClick={handleRefresh} loading={loader} />
      </div>
      <Gap height={30} />
      {/* <Link to="/anggota/3/0/0" className="boxhead"> */}
      {loader ? (
        <SkeletonOverview />
      ) : (
        <>
          <div className="overview-section-container">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <h3 className="overview-header">Anggota</h3>
              </Grid>
            </Grid>
            <Grid container spacing={3} alignItems="stretch">
              <Grid item xs={12} sm={6} md={6} style={{ display: "flex" }}>
                <div
                  // onClick={() => navigate("/anggota/3/0/0")}
                  className="boxhead"
                  style={{ display: "flex", flex: 1, flexDirection: "column" }}
                >
                  <div
                    className="overview-metric-card overview-metric-card--highlight"
                    style={{ flex: 1 }}
                  >
                    <p className="overview-card-title">
                      Jumlah Anggota Pemilu 2029 per 1 Januari 2025
                    </p>
                    <div className="overview-data-grid three-cols">
                      <div className="overview-data-column">
                        <p className="overview-subtitle-value">
                          EXCO Sudah Terbentuk
                        </p>
                        <p className="overview-value-orange">
                          {countAnggota(
                            dataOverview?.dataOverviewKabkot?.data?.data,
                            true,
                            "jumlah_anggota_2029",
                          )
                            .toLocaleString()
                            .replace(/,/g, ".")}
                        </p>
                      </div>
                      <div className="overview-data-column">
                        <p className="overview-subtitle-value">
                          EXCO Belum Terbentuk
                        </p>
                        <p className="overview-value-orange">
                          {countAnggota(
                            dataOverview?.dataOverviewKabkot?.data?.data,
                            false,
                            "jumlah_anggota_2029",
                          )
                            .toLocaleString()
                            .replace(/,/g, ".")}
                        </p>
                      </div>
                      <div className="overview-data-column">
                        <p className="overview-subtitle-value">
                          Total Anggota se-Indonesia
                        </p>
                        <p className="overview-value-orange">
                          {countTotalAnggota(
                            dataOverview?.dataOverviewKabkot?.data?.data,
                            "jumlah_anggota_2029",
                          )
                            .toLocaleString()
                            .replace(/,/g, ".")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} style={{ display: "flex" }}>
                <div
                  // onClick={() => navigate("/anggota/3/0/0")}
                  className="boxhead"
                  style={{ display: "flex", flex: 1, flexDirection: "column" }}
                >
                  <div
                    className="overview-metric-card overview-metric-card--highlight"
                    style={{ flex: 1 }}
                  >
                    <p className="overview-card-title">
                      Capaian Target Anggota Kabupaten/Kota
                    </p>
                    <div className="overview-data-grid">
                      {/* <div className="overview-data-column">
                        <p className="overview-subtitle-value">
                          EXCO Sudah Terbentuk
                        </p>
                        {(() => {
                          const data =
                            dataOverview?.dataOverviewKabkot?.data?.data;
                          let count = 0;
                          let countCities = 0;
                          for (let i = 0; i < data?.length; i++) {
                            if (data[i].is_verified === 1) {
                              countCities++;
                              if (data[i].jumlah_anggota >= data[i].target_pb) {
                                count++;
                              }
                            }
                          }
                          const progress =
                            countCities === 0 ? 0 : (count / countCities) * 100;
                          return (
                            <p className="overview-value-orange">
                              {count}
                              <span className="overview-value-secondary">
                                /{countCities} ({progress.toFixed(2)}%)
                              </span>
                            </p>
                          );
                        })() || 0}
                      </div> */}
                      <div className="overview-data-column">
                        <p className="overview-subtitle-value">
                          Berdasarkan Target Partai Buruh
                        </p>
                        {(() => {
                          const data =
                            dataOverview?.dataOverviewKabkot?.data?.data;
                          let count = 0;
                          let countCities = 0;
                          for (let i = 0; i < data?.length; i++) {
                            countCities++;
                            if (data[i].jumlah_anggota >= data[i].target_pb) {
                              count++;
                            }
                          }
                          const progress =
                            countCities === 0 ? 0 : (count / countCities) * 100;
                          return (
                            <p className="overview-value-orange">
                              {count}
                              <span className="overview-value-secondary">
                                /{countCities} ({progress.toFixed(2)}%)
                              </span>
                            </p>
                          );
                        })() || 0}
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <br />
            <Grid spacing={3} alignItems="stretch">
              <Grid item xs={12} sm={12} md={12} style={{ display: "flex" }}>
                <div
                  // onClick={() => navigate("/anggota/3/0/0")}
                  className="boxhead"
                  style={{ display: "flex", flex: 1, flexDirection: "column" }}
                >
                  <div className="overview-metric-card" style={{ flex: 1 }}>
                    <p className="overview-card-title">
                      Jumlah Anggota Pemilu 2024 s.d 31 Desember 2024
                    </p>
                    <div className="overview-data-grid single-col">
                      <div style={{ marginTop: -20 }}>
                        <p className="overview-subtitle-value">
                          Total Anggota Se-Indonesia
                        </p>
                        <p className="overview-value-orange">
                          {countTotalAnggota(
                            dataOverview?.dataOverviewKabkot?.data?.data,
                            "jumlah_anggota_2024",
                          )
                            .toLocaleString()
                            .replace(/,/g, ".")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <div style={{ marginBottom: 40 }} />
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className="overview-paper-card">
                  <Line
                    options={options}
                    data={data}
                    height="370px"
                    width="100%"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
          <Gap height={30} />
          <div className="overview-section-container">
            <h3 className="overview-header" style={{ marginBottom: 10 }}>
              Kepengurusan 2026-2031
            </h3>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className="overview-metric-card">
                  {/* <p
                    className="overview-card-title"
                    style={{ marginBottom: 24 }}
                  >
                    Kepengurusan 2026-2031
                  </p> */}

                  <div className="seven-cols">
                    <div>
                      <p className="overview-subtitle-value">Tingkat Pusat</p>
                      <p className="overview-value-orange">
                        {dataPengurus?.data?.total_organisasi?.pusat}
                        {!loader && (
                          <span className="overview-value-secondary">
                            /{dataPengurus?.data?.total_wilayah?.pusat} (
                            {persentase(
                              dataPengurus?.data?.total_organisasi?.pusat,
                              dataPengurus?.data?.total_wilayah?.pusat,
                              0,
                            )}
                            %)
                          </span>
                        )}
                      </p>
                    </div>
                    <div>
                      <p className="overview-subtitle-value">
                        Tingkat Provinsi
                      </p>
                      <p className="overview-value-orange">
                        {loader
                          ? "..."
                          : countPengurusDaerah(
                              dataOverview?.dataOverviewProvinsi?.data?.data,
                              verified_region,
                              "jumlah_pengurus",
                            )}{" "}
                        {!loader && (
                          <span className="overview-value-secondary">
                            /
                            {countDaerah(
                              dataOverview?.dataOverviewProvinsi?.data?.data,
                              verified_region,
                            )}{" "}
                            (
                            {persentase(
                              countPengurusDaerah(
                                dataOverview?.dataOverviewProvinsi?.data?.data,
                                verified_region,
                                "jumlah_pengurus",
                              ),
                              countDaerah(
                                dataOverview?.dataOverviewProvinsi?.data?.data,
                                verified_region,
                              ),
                              0,
                            )}
                            %)
                          </span>
                        )}
                      </p>
                    </div>
                    <div>
                      <p className="overview-subtitle-value">
                        Tingkat Kab/Kota
                      </p>
                      <p className="overview-value-orange">
                        {countPengurusDaerah(
                          dataOverview?.dataOverviewKabkot?.data?.data,
                          verified_region,
                          "jumlah_pengurus_kabkot",
                        )}{" "}
                        {!loader && (
                          <span className="overview-value-secondary">
                            /
                            {countDaerah(
                              dataOverview?.dataOverviewKabkot?.data?.data,
                              verified_region,
                            )}{" "}
                            (
                            {persentase(
                              countPengurusDaerah(
                                dataOverview?.dataOverviewKabkot?.data?.data,
                                verified_region,
                                "jumlah_pengurus_kabkot",
                              ),
                              countDaerah(
                                dataOverview?.dataOverviewKabkot?.data?.data,
                                verified_region,
                              ),
                              0,
                            )}
                            %)
                          </span>
                        )}
                      </p>
                    </div>
                    <div>
                      <p className="overview-subtitle-value">
                        Tingkat Kecamatan
                      </p>
                      <p className="overview-value-orange">
                        {countPengurusDaerah(
                          dataOverview?.dataOverviewKecamatan?.data?.data,
                          verified_region,
                          "jumlah_pengurus_kecamatan",
                        )
                          ?.toLocaleString()
                          .replace(/,/g, ".")}{" "}
                        {!loader && (
                          <span className="overview-value-secondary">
                            /{(5464).toLocaleString().replace(/,/g, ".")} (
                            {persentase(
                              countPengurusDaerah(
                                dataOverview?.dataOverviewKecamatan?.data?.data,
                                verified_region,
                                "jumlah_pengurus_kecamatan",
                              ),
                              5464,
                              3,
                            )}
                            %)
                          </span>
                        )}
                      </p>
                    </div>
                    <div>
                      <p className="overview-subtitle-value">
                        Tingkat Kelurahan/Desa
                      </p>
                      <p className="overview-value-orange">
                        {(
                          dataOverview?.dataOverviewKelurahan?.data?.data
                            ?.total_pengurus || 0
                        )
                          ?.toLocaleString()
                          .replace(/,/g, ".")}{" "}
                        {!loader && (
                          <span className="overview-value-secondary">
                            /{(41869).toLocaleString().replace(/,/g, ".")} (
                            {persentase(
                              dataOverview?.dataOverviewKelurahan?.data?.data
                                ?.total_pengurus || 0,
                              41869,
                              3,
                            )}
                            %)
                          </span>
                        )}
                      </p>
                    </div>
                    <div>
                      <p className="overview-subtitle-value">Tingkat RT/RW</p>
                      <p className="overview-value-orange">
                        {(
                          dataOverview?.dataOverviewRtRw?.data?.data
                            ?.total_pengurus || 0
                        )
                          ?.toLocaleString()
                          .replace(/,/g, ".")}{" "}
                        {!loader && (
                          <span className="overview-value-secondary">
                            /{(410081).toLocaleString().replace(/,/g, ".")} (
                            {persentase(
                              dataOverview?.dataOverviewRtRw?.data?.data
                                ?.total_pengurus || 0,
                              410081,
                              3,
                            )}
                            %)
                          </span>
                        )}
                      </p>
                    </div>
                    <div>
                      <p className="overview-subtitle-value">
                        Tingkat Komisaris Basis
                      </p>
                      <p className="overview-value-orange">
                        {(
                          dataOverview?.dataOverviewKomisarisBasis?.data?.data
                            ?.total_pengurus || 0
                        )
                          ?.toLocaleString()
                          .replace(/,/g, ".")}
                      </p>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <div style={{ height: 40 }} />
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                style={{ display: "flex", alignItems: "center" }}
              >
                <h3 className="overview-header" style={{ marginBottom: -20 }}>
                  Keterwakilan Perempuan 2026-2031
                </h3>
              </Grid>
            </Grid>
            <div style={{ height: 40 }} />
            <Grid container spacing={3} alignItems="stretch">
              {/* ===== PUSAT ===== */}
              <Grid item xs={12} sm={6} md={3} style={{ display: "flex" }}>
                <div
                  className="boxhead"
                  style={{ display: "flex", flex: 1, flexDirection: "column" }}
                >
                  <div className="overview-metric-card" style={{ flex: 1 }}>
                    <p
                      className="overview-card-title"
                      style={{ marginBottom: 16 }}
                    >
                      % Pengurus Perempuan Pusat
                    </p>
                    {(() => {
                      const summary = countPengurusPerempuanSummary(
                        dataExcoPusat?.data?.data,
                        "total_pengurus",
                        "total_pengurus_perempuan",
                      );
                      return (
                        <p className="overview-value-orange">
                          {summary.perempuan
                            .toLocaleString()
                            .replace(/,/g, ".")}
                          <span className="overview-value-secondary">
                            /{summary.total.toLocaleString().replace(/,/g, ".")}{" "}
                            ({summary.persen}%)
                          </span>
                        </p>
                      );
                    })()}
                  </div>
                </div>
              </Grid>
              {/* ===== PROVINSI ===== */}
              <Grid item xs={12} sm={6} md={3} style={{ display: "flex" }}>
                <div
                  className="boxhead"
                  style={{ display: "flex", flex: 1, flexDirection: "column" }}
                >
                  <div className="overview-metric-card" style={{ flex: 1 }}>
                    <p
                      className="overview-card-title"
                      style={{ marginBottom: 16 }}
                    >
                      % Pengurus Perempuan Provinsi
                    </p>
                    {(() => {
                      const summary = countPengurusPerempuanSummary(
                        dataOverview?.dataOverviewProvinsi?.data?.data,
                        "jumlah_pengurus",
                        "jumlah_pengurus_perempuan",
                      );
                      return (
                        <p className="overview-value-orange">
                          {summary.perempuan
                            .toLocaleString()
                            .replace(/,/g, ".")}
                          <span className="overview-value-secondary">
                            /{summary.total.toLocaleString().replace(/,/g, ".")}{" "}
                            ({summary.persen}%)
                          </span>
                        </p>
                      );
                    })()}
                  </div>
                </div>
              </Grid>
              {/* ===== KAB/KOTA ===== */}
              <Grid item xs={12} sm={6} md={3} style={{ display: "flex" }}>
                <div
                  className="boxhead"
                  style={{ display: "flex", flex: 1, flexDirection: "column" }}
                >
                  <div className="overview-metric-card" style={{ flex: 1 }}>
                    <p
                      className="overview-card-title"
                      style={{ marginBottom: 16 }}
                    >
                      % Pengurus Perempuan Kab/Kota
                    </p>
                    {(() => {
                      const summary = countPengurusPerempuanSummary(
                        dataOverview?.dataOverviewKabkot?.data?.data,
                        "jumlah_pengurus_kabkot",
                        "jumlah_pengurus_kabkot_perempuan",
                      );
                      return (
                        <p className="overview-value-orange">
                          {summary.perempuan
                            .toLocaleString()
                            .replace(/,/g, ".")}
                          <span className="overview-value-secondary">
                            /{summary.total.toLocaleString().replace(/,/g, ".")}{" "}
                            ({summary.persen}%)
                          </span>
                        </p>
                      );
                    })()}
                  </div>
                </div>
              </Grid>
              {/* ===== KECAMATAN ===== */}
              <Grid item xs={12} sm={6} md={3} style={{ display: "flex" }}>
                <div
                  className="boxhead"
                  style={{ display: "flex", flex: 1, flexDirection: "column" }}
                >
                  <div className="overview-metric-card" style={{ flex: 1 }}>
                    <p
                      className="overview-card-title"
                      style={{ marginBottom: 16 }}
                    >
                      % Pengurus Perempuan Kecamatan
                    </p>
                    {(() => {
                      const summary = countPengurusPerempuanSummary(
                        dataOverview?.dataOverviewKecamatan?.data?.data,
                        "jumlah_pengurus_kecamatan",
                        "jumlah_pengurus_kecamatan_perempuan",
                      );
                      return (
                        <p className="overview-value-orange">
                          {summary.perempuan
                            .toLocaleString()
                            .replace(/,/g, ".")}
                          <span className="overview-value-secondary">
                            /{summary.total.toLocaleString().replace(/,/g, ".")}{" "}
                            ({summary.persen}%)
                          </span>
                        </p>
                      );
                    })()}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          {/* </Link> */}
          <Gap height={30} />
          <div className="overview-section-container">
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                style={{ display: "flex", alignItems: "center" }}
              >
                <h3 className="overview-header" style={{ marginBottom: -20 }}>
                  Kelengkapan Persyaratan Pemilu 2029
                </h3>
              </Grid>
            </Grid>
            <div style={{ height: 40 }} />
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className="overview-metric-card">
                  <p
                    className="overview-card-title"
                    style={{ marginBottom: 24 }}
                  >
                    Kelengkapan Data dan Dokumen
                  </p>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={3}>
                      <p className="overview-subtitle-value">EXCO Pusat</p>
                      <p className="overview-value-orange">
                        {(() => {
                          const dok = countDokumenLengkapSummary(
                            dataExcoPusat?.data?.data,
                            "status_dokumen",
                          );
                          return (
                            <>
                              {dok.terisi.toLocaleString().replace(/,/g, ".")}
                              <span className="overview-value-secondary">
                                /{dok.total.toLocaleString().replace(/,/g, ".")}
                              </span>
                            </>
                          );
                        })()}
                      </p>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <div
                        // onClick={() => navigate("/dokumen/2/0/0")}
                        className="boxhead"
                      >
                        <p className="overview-subtitle-value">EXCO Provinsi</p>
                        <p className="overview-value-orange">
                          {(() => {
                            const dok = countDokumenLengkapSummary(
                              dataOverview?.dataOverviewProvinsi?.data?.data,
                            );
                            return (
                              <>
                                {dok.terisi.toLocaleString().replace(/,/g, ".")}
                                <span className="overview-value-secondary">
                                  /
                                  {dok.total
                                    .toLocaleString()
                                    .replace(/,/g, ".")}
                                </span>
                              </>
                            );
                          })()}
                        </p>
                      </div>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <div
                        // onClick={() => navigate("/dokumen/3/0/0")}
                        className="boxhead"
                      >
                        <p className="overview-subtitle-value">EXCO Kab/Kota</p>
                        <p className="overview-value-orange">
                          {(() => {
                            const dok = countDokumenLengkapSummary(
                              dataOverview?.dataOverviewKabkot?.data?.data,
                            );
                            return (
                              <>
                                {dok.terisi.toLocaleString().replace(/,/g, ".")}
                                <span className="overview-value-secondary">
                                  /
                                  {dok.total
                                    .toLocaleString()
                                    .replace(/,/g, ".")}
                                </span>
                              </>
                            );
                          })()}
                        </p>
                      </div>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <div
                        // onClick={() => navigate("/dokumen/4/0/0")}
                        className="boxhead"
                      >
                        <p className="overview-subtitle-value">
                          EXCO Kecamatan
                        </p>
                        <p className="overview-value-orange">
                          {(() => {
                            const dok = countDokumenLengkapSummary(
                              dataOverview?.dataOverviewKecamatan?.data?.data,
                            );
                            return (
                              <>
                                {dok.terisi.toLocaleString().replace(/,/g, ".")}
                                <span className="overview-value-secondary">
                                  /
                                  {dok.total
                                    .toLocaleString()
                                    .replace(/,/g, ".")}
                                </span>
                              </>
                            );
                          })()}
                        </p>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </div>
          <Gap height={20} />
          <div className="footer-content"></div>
        </>
      )}
    </div>
  );
};

export default DetailOverview;
